import React, { useState } from 'react';

interface IframeContentProps {
  src: string;
  height?: number;
  width?: string;
  title?: string;
}

export const IframeContent: React.FC<IframeContentProps> = ({
  src,
  height = 500,
  width = '100%',
  title = 'Embedded content'
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  // Handle iframe load events
  const handleLoad = () => {
    setIsLoading(false);
  };

  const handleError = () => {
    setIsLoading(false);
    setError('Failed to load embedded content');
  };

  if (!src) {
    return (
      <div className="w-full p-4 bg-red-50 text-red-600 border border-red-200 rounded-md my-2">
        Error: No source URL provided for embedded content
      </div>
    );
  }

  return (
    <div className="w-full my-4 border rounded-md overflow-hidden bg-white">
      {isLoading && (
        <div className="flex items-center justify-center h-24">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
        </div>
      )}
      
      {error && (
        <div className="w-full p-4 bg-red-50 text-red-600 border border-red-200 rounded-md">
          {error}
        </div>
      )}
      
      <iframe
        src={src}
        width={width}
        height={height}
        title={title}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        onLoad={handleLoad}
        onError={handleError}
        style={{ 
          display: isLoading ? 'none' : 'block',
          border: 'none'
        }}
      ></iframe>
    </div>
  );
}; 